module.exports = __webpack_public_path__ + "static/media/isdoctorplan-spine-thoracic2.e23ffb02.png";